/* A count as a reader scans it in a column: "1.2M rows", "4.1k violations".
 *
 * **Here rather than in each feature**, for `age.ts`' reason: the redesign compacts large figures on
 * several screens — run findings, usage, source tables — and two spellings of "1.2 million" is the
 * two-vocabularies failure at its smallest. Below a thousand the figure is printed whole, because
 * "742" is already as short as a reader needs and "0.7k" would be a rounding nobody asked for.
 *
 * Display only. A figure a reader acts on precisely — a total on an invoice, a limit — is printed in
 * full by its own screen; this is for a column whose job is the order of magnitude.
 */

const COMPACT = new Intl.NumberFormat(undefined, {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function compactNumber(value: number): string {
  return Math.abs(value) < 1000 ? value.toLocaleString() : COMPACT.format(value);
}
